
// helpers related to send-app-link

/**
 * validate mobile string:
 * xxx-xxx-xxxx
 */
export function validateNumber(value: string): boolean {
  const numberRegex = /^\d{3}-\d{3}-\d{4}$/
  return numberRegex.test(value)
}

/**
 * validate email string
 */
export function validateEmail(value: string): boolean {
  // tslint:disable-next-line: tsr-detect-unsafe-regexp
  const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  return emailRegex.test(value)
}

/**
 * place charSymbol into arr by position;
 * @param arr - arr where to place
 * @param position - can be arr.length
 * @param charSymbol - e.g. /
 * @returns new string
 */
function insertSymbol(arr: any[], position: number, charSymbol: string): string {
  arr.splice(position, 0, charSymbol)
  return arr.join('')
}

/**
 * remove charSymbol from arr (by lastIndexOf);
 * @param arr - arr where to place
 * @param charSymbol - e.g. /
 * @returns new string
 */
function deleteSymbol(arr: any[], charSymbol: string): string {
  const i = arr.lastIndexOf(charSymbol)
  if (i !== -1) {
    arr.splice(i, 1)
  }
  return arr.join('')
}



/**
 * remove all "-" and set them again in correct positions: xxx-xxx-xxxx
 * @param input - mobile number
 * @returns new string
 */
export function mobileHyphensSetInstead(input: string): string {
  const phone = input

  const noHyphens = phone.split('-').join('')

  const mobArray = Array.from(noHyphens)
  const firstTripletPosition = 3
  const secondTripletPosition = 7
  let targetElement: string

  if (mobArray.length > firstTripletPosition) {
    targetElement = insertSymbol(mobArray, firstTripletPosition, '-')
  }
  if (mobArray.length > secondTripletPosition) {
    targetElement = insertSymbol(mobArray, secondTripletPosition, '-')
  }

  return targetElement

}

/**
 * remove all "-" and set them again in correct positions xxx-xx-xxxx
 * @param input - ssn
 * @returns new string
 */
export function ssnHyphensSetInstead(input: string): string {
  const ssn = input

  const noHyphens = ssn.split('-').join('')

  const mobArray = Array.from(noHyphens)
  const firstTripletPosition = 3
  const secondTripletPosition = 6
  let targetElement: string

  if (mobArray.length > firstTripletPosition) {
    targetElement = insertSymbol(mobArray, firstTripletPosition, '-')
  }
  if (mobArray.length > secondTripletPosition) {
    targetElement = insertSymbol(mobArray, secondTripletPosition, '-')
  }

  return targetElement

}

/**
 * splits date by /, add '0' if need and return
 * @param input - date string
 * @returns new string
 */
function pasteZeros(input: string): string {
  const res = input.split('/')
  if (res.length === 3) {
    if (res[0].length === 1) {
      res[0] = '0' + res[0]
    }
    if (res[1].length === 1) {
      res[1] = '0' + res[1]
    }
    return res.join('/')
  }
  return input
}

/**
 * for date - paste zeros & paste / in correct positions
 * @param input - date
 * @returns new date
 */
export function dateDashesSetInstead(input: string): string {
  const dateOfBirth = input

  // at first paste zeros
  const allZerosCompleted = pasteZeros(dateOfBirth)

  const noDashes = allZerosCompleted.split('/').join('')

  const noDashesArray = Array.from(noDashes)
  const firstTripletPosition = 2
  const secondTripletPosition = 5
  let targetElement: string

  if (noDashesArray.length > firstTripletPosition) {
    targetElement = insertSymbol(noDashesArray, firstTripletPosition, '/')
  }
  if (noDashesArray.length > secondTripletPosition) {
    targetElement = insertSymbol(noDashesArray, secondTripletPosition, '/')
  }

  return targetElement

}

/**
 * paste hyphens on input (in dynamic)
 * @param e - event
 * @param targetElement - input element
 * @returns targetElement
 */
export function mobileHyphensComplete(e: any, targetElement: any): any {
  const phone = e.target.value

  const mobArray = Array.from(phone)
  const firstTripletPosition = 3
  const secondTripletPosition = 7

  if (phone.length > secondTripletPosition + 1) {
    if (mobArray[firstTripletPosition] === '-'
    && mobArray[secondTripletPosition] === '-') {
      return e.target
    }
  }

  if ((phone.length === firstTripletPosition || phone.length === secondTripletPosition)
    && e.inputType !== 'deleteContentBackward') {
    targetElement.value = insertSymbol(mobArray, mobArray.length, '-')
    return targetElement
  }
  if ((phone.length === firstTripletPosition + 1 || phone.length === secondTripletPosition + 1)
    && e.inputType === 'deleteContentBackward') {
    targetElement.value = deleteSymbol(mobArray, '-')
    return targetElement
  }

  if (e.inputType === 'insertFromPaste' || e.inputType === undefined) {
    if (mobArray.length >= secondTripletPosition + 1
      && mobArray.length <= secondTripletPosition) {
      targetElement.value = insertSymbol(mobArray, firstTripletPosition, '-')
    }
    if (mobArray.length >= secondTripletPosition + 1) {
      targetElement.value = insertSymbol(mobArray, firstTripletPosition, '-')
      targetElement.value = insertSymbol(mobArray, secondTripletPosition, '-')
    }
    return targetElement
  }
}

/**
 * paste hyphens on input (in dynamic)
 * @param e - event
 * @param targetElement - input element
 * @returns targetElement
 */
export function ssnHyphensComplete(e: any, targetElement: any): any {
  const ssn = e.target.value

  const ssnArr = Array.from(ssn)
  const firstTripletPosition = 3
  const secondTripletPosition = 6

  if (ssn.length > secondTripletPosition + 1) {
    if (ssnArr[firstTripletPosition] === '-'
    && ssnArr[secondTripletPosition] === '-') {
      return e.target
    }
  }

  if ((ssn.length === firstTripletPosition || ssn.length === secondTripletPosition)
    && e.inputType !== 'deleteContentBackward') {
    targetElement.value = insertSymbol(ssnArr, ssnArr.length, '-')
    return targetElement
  }
  if ((ssn.length === firstTripletPosition + 1 || ssn.length === secondTripletPosition + 1)
    && e.inputType === 'deleteContentBackward') {
    targetElement.value = deleteSymbol(ssnArr, '-')
    return targetElement
  }

  if (e.inputType === 'insertFromPaste' || e.inputType === undefined) {
    if (ssnArr.length >= secondTripletPosition + 1
      && ssnArr.length <= secondTripletPosition) {
      targetElement.value = insertSymbol(ssnArr, firstTripletPosition, '-')
    }
    if (ssnArr.length >= secondTripletPosition + 1) {
      targetElement.value = insertSymbol(ssnArr, firstTripletPosition, '-')
      targetElement.value = insertSymbol(ssnArr, secondTripletPosition, '-')
    }
    return targetElement
  }
}

export const sendAppLinkSuccessMessage = 'Message has been sent successfully.'
export const mobileErrorMessage = 'Error: Invalid phone number, try again.'
export const emailErrorMessage = 'Error: Invalid email, try again.'
